import React from 'react'

import useSwr from 'swr'

import { Form } from '_zari/core'

import * as TransaccionService from 'services/transaccion.service'

const TransaccionSelect = ({ transaccion, oneRowTrigger, ...props }) => {
  const fetcher = () => TransaccionService.obtenerxCodigoAsSelectModelosCuenta12(transaccion).then(({ data }) => data)

  const { data: transacciones } = useSwr(`select_transacciones_${transaccion}`, fetcher, {
    initialData: [],
    revalidateOnMount: true,
    revalidateOnFocus: false,
    dedupingInterval: 1000 * 60 * 15
  })

  React.useEffect(() => {
    if (transacciones.length > 0 && oneRowTrigger) {
      oneRowTrigger(transacciones[0])
    }
  }, [transacciones, oneRowTrigger])

  return (
    <Form.Select {...props}>
      <option value=''>Seleccionar</option>
      {transacciones.map((val, key) => (
        <option key={key} value={val._id}>
          {val.descripcion}
        </option>
      ))}
    </Form.Select>
  )
}

export default React.memo(TransaccionSelect)
